// @givmo/app-admin — auth-resolution splash.
//
// Shown ONLY for the brief window between app mount and the first `onAuthStateChanged` emission
// (i.e. while `auth.isReady === false`). It exists to close the cold-load auth race: on a hard
// refresh into a protected route, Firebase rehydrates a persisted session ASYNCHRONOUSLY, so
// `auth.currentUser` is `null` for a moment. If the router (and its `beforeLoad` guard) mounted during
// that window, the guard would see `isAuthenticated === false` and redirect an actually-signed-in
// admin to /login-home. Gating the router on `isReady` means the guard only ever runs against a
// RESOLVED session, so an authed cold-load lands on its route and a genuinely signed-out cold-load
// still ends up at /login-home.
//
// It sits on the auth frame's own background in the brand colour (EP-WEB43), so a cold load does not
// flash a different grey before the sign-in door paints.

import { testIdProp } from '@givmo/design-system';

export function AuthSplash() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-surface-sunken"
      {...testIdProp('admin-auth-splash')}
    >
      <span
        role="status"
        aria-label="Loading"
        className="size-[32px] animate-spin rounded-full border-2 border-brand-600 border-t-transparent"
      />
    </div>
  );
}
